export const shipItemsList = [
    { key: `hardCase`, title: `Hard Case` },
    { key: `acPower`, title: `AC Adapter` },
    { key: `battery`, title: `Battery` },
    { key: `storage`, title: `HDD/SSD` }
]
